export default __webpack_public_path__ + "static/media/jackson.8915a4c3.jpg";